import { render } from "./sampling-status-badge.vue?vue&type=template&id=2a06df75"
import script from "./sampling-status-badge.vue?vue&type=script&lang=js"
export * from "./sampling-status-badge.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__